import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M14.813.338a.75.75 0 0 1 1.015.308l.618 1.155c.185.346.352.66.452.906.052.128.11.294.126.472a.96.96 0 0 1-.208.712.97.97 0 0 1-.674.338 1.8 1.8 0 0 1-.492-.036 12 12 0 0 1-1.041-.28l-.04-.011A9 9 0 0 0 12 3.53c-4.854 0-8.75 3.814-8.75 8.47a8.2 8.2 0 0 0 1.165 4.225.75.75 0 1 1-1.288.768A9.7 9.7 0 0 1 1.75 12c0-5.527 4.61-9.97 10.25-9.97 1.041 0 2.048.152 2.997.434l.122.036-.016-.029-.598-1.117a.75.75 0 0 1 .308-1.016m5.032 6.408a.75.75 0 0 1 1.028.26A9.7 9.7 0 0 1 22.25 12c0 5.527-4.61 9.969-10.25 9.969-1.041 0-2.048-.151-2.997-.433l-.122-.036.016.028.598 1.118a.75.75 0 0 1-1.323.708l-.618-1.155c-.185-.346-.353-.66-.452-.907a1.7 1.7 0 0 1-.126-.472.96.96 0 0 1 .208-.711.97.97 0 0 1 .673-.339c.177-.015.352.01.493.036.274.053.635.16 1.041.28l.04.012c.81.24 1.674.37 2.569.37 4.854 0 8.75-3.812 8.75-8.468 0-1.54-.424-2.982-1.165-4.226a.75.75 0 0 1 .26-1.028",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }